import { SwapWidget, darkTheme, Theme } from '@uniswap/widgets'
import { BigNumber, ethers } from 'ethers';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createProvider, Eip1193, networkToChainId } from "../../constants/EIP1193";
import back from '../../styles/assets/back_arrow.svg';
import down from '../../styles/assets/down_arrow.svg';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from "../../constants/storage_constats";
import { abi as ERC20_ABI } from '../../contract_abis/erc20_rw';
import { ERC721 } from '../../contract_abis/ERC721';
import { ERC1155 } from '../../contract_abis/ERC1155';
import { toast } from 'react-toastify';
import Transaction from '../uiComponents/Toasts/Transaction';
import { sendTXConfirmationToDevices, TXDescriptionEnum, TXNamesEnum } from '../../services/backendHelpers';
import { removeSubscribeBack, subscribeBack } from '../../services/androidCallback';
import { eventTracker } from '../../services/eventTracker';

import {checkBalance, initiateTransfer} from '../../services/transferHelpers';

const CoinGecko = require('coingecko-api');

const SeedPhraseTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const Amount = styled.input`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    background: transparent;
    color: #fff;
    border: none;
    width: 160px;
`;

const Price = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    font-variant: small-caps;
    color: #616685;
`;

const Tag = styled.div`
    background: #26283E;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #fff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    padding: 6px 12px;
    width: fit-content;
`;

const Address = styled.textarea`
    background: #171929;
    border-radius: 12px;
    padding: 21px 13px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    width: inherit;
    margin: 16px;
    margin-top: 40px;
    border: none;
    min-height: 122px;
    resize: none;
`;

const DisabledButton = styled.div`
    background: #141624;
    border-radius: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #616685;
    padding: 12px;
    width: 85vw;
    text-align: center;
`;

const ActiveButton = styled.div`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    border-radius: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #fff;
    padding: 12px;
    width: 85vw;
    text-align: center;
`;

const UNISWAP_TOKEN_LIST = 'https://xtremeverse.s3.ap-south-1.amazonaws.com/tokens.uniswap.org'

enum TokenTypes {
  ERC20 = 'ERC20',
  ERC721 = 'ERC721',
  ERC1155 = 'ERC1155',
  ERC721_LAZY = 'ERC721_LAZY',
  ERC1155_LAZY = 'ERC1155_LAZY',
  ETH = 'ETH',
}

/* A React component that is used to transfer tokens from one 
 to another. */
const TransferTokens = (props: any) => {
  const location: any = useLocation();
  const [amount, setAmount] = useState('');
  const [token, setToken] = useState(location.state);
  const [transferActive, setTransferActive] = useState(false);
  const [price, setPrice] = useState(0);
  const [address, setAddress] = useState('');
  const [transferText, setTransferText] = useState('Transfer');
  const toastId = React.useRef(null as any);

  const navigate: any = useNavigate();
  console.log(location)
  const CoinGeckoClient = new CoinGecko();

  var getPrice = async () => {
    console.log(token)
    // console.log(token.currency.coingeckoId, '=================== coingeckoId');
    // console.log(token.type, '=================== token type')
    if (token.type === TokenTypes.ERC20 || token.type === TokenTypes.ETH) {
      let data: any = await CoinGeckoClient.simple.price({
        ids: [token.currency.coingeckoId]
      });
      return data;
    } else {
      return null;
    }
    
  };

  useEffect(() => {
    // register backpress
    subscribeBack();
    (window as any).callbackBackPressed  = () => {
      // unregister the callback
      goBack();
    };
  }, [])

  const goBack = () => {
    removeSubscribeBack();
    navigate(-1);
  };

  useEffect(() => {
      const fetchPrice = async () => {
          // console.log(await getPrice());
          try{
              const data: any = await getPrice();
              console.log(data, '=================== price data');
              (data) ? setPrice(data.data[token.currency.coingeckoId].usd) : setPrice(0) ;
          }
          catch(e){}
      }
      fetchPrice();
  }, []);
    

  // useffect to check if address, amount and balance are valid
  useEffect(() => {
      if ((address && amount && checkBalance(token, amount)) || (token.type !== 'ERC20' && address && checkBalance(token, amount))) {
          setTransferActive(true);
    } else {
      setTransferActive(false);
    }
  }, [address, amount]);

  return (
    <div className="Uniswap" style={{
      flexDirection: 'column',
      background: 'rgb(15,15,15)',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '100%',
      padding: 16
    }}>
      <div onClick={() => goBack()} style={{ position: 'absolute', top: 0, left: 20 }}>
        <img style={{ position: 'absolute', top: 20 }} src={back} alt='back arrow' className='hover' />
        <SeedPhraseTitle className='hover' style={{ display: 'flex', justifyContent: 'center', marginTop: 16, marginLeft: 30 }}>
          Transfer
        </SeedPhraseTitle>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '95vh' }}>
        <div style={{
          padding: 12,
          marginTop: 180,
          display: 'flex',
          justifyContent: 'flex-start',
          width: '85vw',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <div style={{
            display: 'flex',
            justifyContent: token.type === 'ERC20' ? 'space-between': 'center',
            width: token.type === 'ERC20' ? '100%': 'auto',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1
            }}
            >
              {token.type === 'ERC721' ? 
                <>
                </>
              :
                <>
                  <Amount
                    type='number'
                    value={amount}
                    onChange={(event) => {
                      console.log(token)
                      if(event.target.value.endsWith('.') || !event.target.value.includes('.') || (event.target.value.split('.')[1] && event.target.value.split('.')[1].length <= token.decimals)) 
                        setAmount(event.target.value)
                    }}
                    placeholder='0.0'
                  />
                  <Price>${parseFloat((price * Number(amount)).toFixed(6))}</Price>
                </>
              }
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              flex: 1
            }}
            >
              <Tag>
                <img src={token.image?token.image:token.imageUri} alt='symbol icon' style={{ width: 24, height: 24 }} />
                <span style={{ marginLeft: 8 }}>
                  {token.symbol}
                </span>
              </Tag>
              {token.type === 'ERC20' && <Price>1USDC - ${parseFloat(price.toFixed(6))}</Price>}
            </div>
          </div>

          <img alt="down arrow" src={down} style={{ width: 20, marginTop: 40 }} />

          <Address onChange={(event) => {
            if (ethers.utils.isAddress(event.target.value)) {
              setAddress(event.target.value);
            } else {              
              setAddress('');
            }
          }} placeholder='Enter 
           address'></Address>
        </div>

        {!transferActive ? <DisabledButton>
          {address === '' ? <>Enter address first</> :
           amount === '' ? <>Enter amount</> : 
           !checkBalance(token, amount) && <>Not enough balance</>}
        </DisabledButton>
        :
         <ActiveButton onClick={() => {
             try{
                 initiateTransfer({
                     setTransferActive,
                     setTransferText,
                     goBack,
                     amount,
                     toastId,
                     token,
                     address
                 });
                 eventTracker('initiate_transfer_click', {
                     address: address,
                     amount: amount,
                     token: token,
                     price: price
                 });
             }catch(e){
                 console.log(e);
                 toastId.current = toast(<Transaction type={'pending'}/>, {
                     position: toast.POSITION.BOTTOM_CENTER,
                     autoClose: false,
                     theme: 'dark',
                     icon: false,
                     closeButton: false,            
                 });
             }
        }}>
          {transferText}
         </ActiveButton>
}
    </div>
    </div>
  );
}

export default TransferTokens;
